import {
  AutoComplete,
  Button,
  Input,
  InputRef,
  Modal,
  Popconfirm,
  Radio,
  Space,
  Table,
  Tooltip,
  notification,
  Tree,
  Tag,
  Popover,
  ConfigProvider,
  Spin,
  Row,
  Col,
} from "antd";
import NoPosition from "../../assets/vectors/NoPositionVector.png";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetMyPosition,
  GetPositionRoleByPositionIdAndRole,
} from "../../services/PositionService";
import { ColumnType, ColumnsType, TableProps } from "antd/es/table";
import {
  ApiOutlined,
  EditOutlined,
  MailOutlined,
  RedoOutlined,
  SearchOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { FilterConfirmProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import {
  SendInvitationEmail,
  SendInvitationSms,
  UpdateInvitation,
} from "../../services/InvitationService";
import axios from "axios";
import { GURL } from "../../services/global";
import { NotificationPlacement } from "antd/es/notification/interface";
import { ColorPalette } from "../share/color/colorPalette";
import CustomButton from "../share/customButton";
import NewCompanyInvitation from "./NewCompanyInvitation";
import { SendMail } from "../../services/CommiunicationService";
import faIR from "antd/lib/locale/fa_IR"; // Import Persian locale
import { GetInvitationsOData } from "../../services/InvitationODataSevice";
import { Card } from "@material-ui/core";
import CompanyIcon from "../icons/NoticeCard/CompanyIcon";
import TedInvitationSideBarCompanyIcon from "../icons/TedInvitationSideBarCompanyIcon";
import TedSaveIcon from "../icons/TedSaveIcon";
import TedShareIcon from "../icons/TedShareIcon";
import ClockIcon from "../icons/NoticeCard/ClockIcon";
import TedOneLineChatIcon from "../icons/TedOneLineChatIcon";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import NewCompanyInvitationV2 from "./NewCompanyInvitationV2";
const CompanyInvitationsV2 = () => {
  const navigate = useNavigate();

  const [SendInvitation, setSendInvitation] = useState(false);
  const [getNewInvitationDialog, SetNewInvitationDialog] = useState(false);
  const dispatch = useDispatch<any>();

  const location = useLocation();
  const searchParamsd = location.search; // Get query string (e.g., "?Add")  // Check if "Add" exists in the query parameters
  const isAddPresent = searchParamsd.includes("Add");
  const myPositions = useSelector(getMyPosition);
  // Start Of Checking User Has Position
  const [myPosition, SetMyPosition] = useState<any>("");
  async function GetMyPositionAsync() {
    await GetMyPosition().then((p) => {
      //console.log("log", p);
      if (p.status === 200) {
        SetMyPosition(p.data);
      } else {
        SetMyPosition(null);
      }
    });
  }

  const [clientHeight, setClientHeight] = useState(0);
  const [clientWidth, setClientWidth] = useState(0);
  const locale = {
    ...faIR,
    Pagination: {
      ...faIR.Pagination,
      items_per_page: "ردیف",
      prev_page: "صفحه قبلی",
      next_page: "صفحه بعدی",
      jump_to: "برو به",
      page: "صفحه",
    },
  };
  // End Of Checking
  useEffect(() => {
    setClientHeight(document.documentElement.clientHeight); // Get clientHeight of the element
    setClientWidth(document.documentElement.clientWidth);
    GetMyPositionAsync();

    dispatch(fetchUserPosition());

    LoadInvitations(pagination.current, pagination.pageSize);

    const handleResize = () => {
      setClientWidth(document.documentElement.clientWidth);
      setClientHeight(document.documentElement.clientHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    console.log("isAddPresent", searchParamsd);
  }, [searchParamsd]);
  //PaginationStart
  const [pagination, setPagination] = useState<any>({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  //PaginationEnd

  //Notifications Start
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (msg: any, placement: NotificationPlacement) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button
          className="iran"
          type="link"
          size="small"
          onClick={() => api.destroy()}
        >
          رد کردن
        </Button>
      </Space>
    );
    api.info({
      message: "پیام",
      description: msg,
      placement,
      btn,
      key,
      className: "iran",
      onClose: close,
    });
  };
  const close = () => {
    console.log(
      "Notification was closed. Either the close button was clicked or duration time elapsed."
    );
  };

  //Notifications End

  //Sorting Methode Start
  const compareValues = (a: any, b: any) => {
    // Handle different data types and null/undefined values
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    } else {
      return a - b;
    }
  };

  //Sorting Methode End

  //Handle Copy Text Start

  const handleCopyContent = (input: string) => {
    const contentToCopy = input; // Replace with the content you want to copy
    const textarea = document.createElement("textarea");
    textarea.value = contentToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    openNotification("متن دعوتنامه جهت ایمیل با موفقیت کپی شد", "bottomRight");
    //console.log("Content copied to clipboard");
  };
  //Handle Copy Text End

  // Check Days Passed
  function checkIfThreeDaysPassed(latestSmsSentDate: string): boolean {
    //console.log("latestSmsSentDate", latestSmsSentDate);
    //return false;
    const today = new Date();
    const sentDate = new Date(latestSmsSentDate);
    const todayUTC = Date.UTC(
      today.getUTCFullYear(),
      today.getUTCMonth(),
      today.getUTCDate()
    );
    const sentDateUTC = Date.UTC(
      sentDate.getUTCFullYear(),
      sentDate.getUTCMonth(),
      sentDate.getUTCDate()
    );
    const differenceInTime = todayUTC - sentDateUTC;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays >= 2;
  }
  //End Check Days Passed

  async function GetPositionRoleByPositionIdAndRoleAsync() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "SendInvitation"
    ).then((p) => setSendInvitation(p.data.data));
  }

  useEffect(() => {
    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync();
      }
    }
  }, [myPositions]);

  // Load Invitations Start
  const [take, setTake] = useState(10);
  const [phoneNumber, setPhoneNumber] = useState("1");

  const [GetButtonCoverId, SetButtonCoverId] = useState<any>(null);

  const [GetInvitationData, SetInvitaionData] = useState<any>(null);
  const [GetInvitationLoading, SetInvitaionLoading] = useState<any>(null);

  const handleTableChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter
  ) => {
    let newSortField = null;
    let newSortOrder = null;

    if (!Array.isArray(sorter)) {
      newSortField = sorter.field as string;
      newSortOrder = sorter.order || null;
    }

    setSortField(newSortField);
    setSortOrder(newSortOrder);

    LoadInvitations(
      pagination.current!,
      pagination.pageSize!,
      newSortField,
      newSortOrder
    );
  };
  const [isRowClicked, setIsRowClicked] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [sortOrder, setSortOrder] = useState<string | null>(null);
  const [sortField, setSortField] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchParams] = useSearchParams();
  useEffect(() => {
    LoadInvitations();
  }, [searchParams]);
  const LoadInvitations = (
    page: number = pagination.current,
    pageSize: number = pagination.pageSize,
    sortFieldParam: string | null = sortField,
    sortOrderParam: string | null = sortOrder
  ) => {
    setLoading(true);

    const skip = (page - 1) * pageSize; // Offset
    const top = pageSize; // Limit

    let orderBy = "$orderby=CreatedDate desc";

    if (sortFieldParam && sortOrderParam) {
      orderBy = `$orderby=${sortFieldParam} ${
        sortOrderParam === "ascend" ? "asc" : "desc"
      }`;
    }

    const filterConditions: string[] = [];
    const phoneEmailConditions: string[] = []; // Separate conditions for PhoneNumber and Email

    // Process the search parameters
    searchParams.forEach((value, key) => {
      // Exclude parameters that should not be in the filter
      if (
        !["page", "pageSize", "sortField", "sortOrder", "tab"].includes(key)
      ) {
        // Special handling for PhoneNumber and Email
        if (key === "PhoneNumber" || key === "Email") {
          phoneEmailConditions.push(`contains(${key}, '${value}')`); // Handle OR for PhoneNumber and Email
        } else {
          filterConditions.push(`contains(${key}, '${value}')`); // General 'contains' filter
        }
      }
    });

    // Join PhoneNumber and Email with 'or'
    const phoneEmailQuery = phoneEmailConditions.length
      ? `(${phoneEmailConditions.join(" or ")})`
      : "";

    // Join other filter conditions with 'and'
    const otherQuery = filterConditions.length
      ? `$filter=${filterConditions.join(" and ")}`
      : "";

    // Combine PhoneNumber/Email filter with other filters (if both exist)
    const finalFilterQuery =
      phoneEmailQuery && otherQuery
        ? `${otherQuery} and ${phoneEmailQuery}`
        : phoneEmailQuery || otherQuery;

    try {
      GetInvitationsOData(top, skip, orderBy, finalFilterQuery)
        .then((response) => {
          setPagination((prev: any) => ({
            ...prev,
            current: page,
            pageSize,
            total: response?.data["@odata.count"], // OData includes total count
          }));
          const dataWithKey = response?.data?.value?.map((item: any) => ({
            ...item,
            key: item.Id, // Assuming 'Id' is the unique identifier
          }));
          SetInvitaionData(dataWithKey);
          setLoading(false);
        })
        .then(() => {
          SetInvitaionLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const LoadInvitations2 = (
    page: number = pagination.current,
    pageSize: number = pagination.pageSize,
    sortFieldParam: string | null = sortField,
    sortOrderParam: string | null = sortOrder
  ) => {
    setLoading(true);
    const skip = (page - 1) * pageSize; // Offset
    const top = pageSize; // Limit
    //      let orderBy = "$orderby=CreatedDate desc";
    //
    //       if (sortFieldParam && sortOrderParam) {
    //         orderBy = `$orderby=${sortFieldParam} ${
    //           sortOrder === "ascend" ? "asc" : "desc"
    //         }`;
    //       }
    let orderBy = "$orderby=CreatedDate desc";

    // If sorting parameters exist, override the default orderBy
    // The sorting field is dynamically set, and the sorting order is mapped from "ascend"/"descend" to "asc"/"desc"
    if (sortFieldParam && sortOrderParam) {
      orderBy = `$orderby=${sortFieldParam} ${
        sortOrder === "ascend" ? "asc" : "desc"
      }`;
    }
    try {
      GetInvitationsOData(top, skip, orderBy)
        .then((response) => {
          setPagination((prev: any) => ({
            ...prev,
            current: page,
            pageSize,
            total: response?.data["@odata.count"], // OData includes total count
          }));
          const dataWithKey = response?.data?.value?.map((item: any) => ({
            ...item,
            key: item.Id, // Assuming 'id' is the unique identifier
          }));
          SetInvitaionData(dataWithKey);
          setLoading(false);
        })
        .then(() => {
          SetInvitaionLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
    }
  };

  useEffect(() => {
    console.log("ODD", GetInvitationData);
  }, [GetInvitationData]);
  // Load Invitations End

  //Search and Filter Operations Start
  interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  }
  type DataIndex = keyof DataType;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex: any): ColumnType<any> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${"..."}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined rev={undefined} />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              handleSearch(selectedKeys as string[], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            پاک کردن
          </Button>
          {/* <AntdButton
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}>
            فیلتر
          </AntdButton> */}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            بستن
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined
        style={{ color: filtered ? "#1677ff" : undefined }}
        rev={undefined}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  //Search and Filter Operations End

  //Update Invitation Start
  async function UpdateInvitationAsync(state: number, invitationId: any) {
    await UpdateInvitation({
      invitationId: invitationId,
      invitationState: state,
    })
      .then(() => LoadInvitations())
      .then(() =>
        openNotification("دعوتنامه مورد نظر شما منقضی شد", "bottomRight")
      );
  }
  //Update Invitation End

  //Table Column Start
  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "5%",
      hidden: false,

      render: (item, record, index) => (
        <>{(pagination.current - 1) * pagination.pageSize + index + 1}</>
      ),
    },

    {
      title: "عنوان فروشگاه",
      dataIndex: "CompanyName",
      key: "CompanyName",
      width: "15%",
      align: "right",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),
      sorter: true,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "نام رابط",
      dataIndex: "FullName",
      key: "FullName",
      width: "10%",

      sorter: true,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "آدرس تماس",
      dataIndex: "PhoneNumber",
      key: "PhoneNumber",
      width: "10%",
      align: "center",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),
      render: (item, record, index) => <>{record.PhoneNumber}</>,
      sorter: true,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "وضعیت",
      dataIndex: "InvitationStatus",
      key: "InvitationStatus",
      width: "5%",
      align: "center",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),

      render: (item, record, index) => <>{record.InvitationStatus}</>,
      sorter: true,
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "تاریخ ارسال",
      dataIndex: "CreatedDate",
      key: "CreatedDate",
      width: "5%",
      align: "center",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),
      render: (item, record, index) => (
        <>{ConvertToShamsi(record.CreatedDate)}</>
      ),
      sorter: true,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: " توضیحات  ",
      dataIndex: "Description",
      key: "Description",
      width: "15%",

      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),
      render: (item, record, index) => <>{record.Description}</>,
      sorter: true,
      sortDirections: ["descend", "ascend"],
    },
    {
      title: " صنف  ",
      dataIndex: "ClassId",
      key: "ClassId",
      hidden: true,
      width: "15%",

      render: (item, record, index) => (
        <>{item !== null ? <Tag color="green">دارد </Tag> : <></>}</>
      ),
      sorter: (a, b) => compareValues(a.classId, b.classId),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "",
      dataIndex: "CreatedDate",
      key: "CreatedDate",
      width: "10%",
      align: "center",
      onHeaderCell: () => ({
        style: {
          height: "52px",
          verticalAlign: "middle",
          textAlign: "center",
        },
      }),
      render: (item, record, index) => (
        <>
          {GetButtonCoverId === record.Id ? (
            <div>
              {/* Popover content is displayed here when the button is clicked */}
              <div>
                {record.ClassId !== null ? <> </> : <> </>}

                <div
                  style={{
                    display:
                      record.Email !== "" && record.PhoneNumber !== "0"
                        ? "inline-block"
                        : "none",
                  }}
                >
                  <Tooltip title={record.Email}>
                    <a className="px-2" style={{ border: "1px" }}>
                      <MailOutlined />
                    </a>
                  </Tooltip>
                </div>

                {record?.InvitationEvents?.filter(
                  (f: any) => f.InvitationEventType === "StateChanged"
                ) // Filter by StateChanged
                  ?.sort(
                    (a: any, b: any) =>
                      new Date(b.ActionDate).getTime() -
                      new Date(a.ActionDate).getTime()
                  ) // Sort descending
                  ?.at(0)?.InvitationState === "Sent" ? (
                  <>
                    {checkIfThreeDaysPassed(
                      record?.InvitationEvents?.filter(
                        (f: any) => f.InvitationAction === "SendInvitationSms"
                      )
                        ?.sort(
                          (a: any, b: any) =>
                            new Date(b.ActionDate).getTime() -
                            new Date(a.ActionDate).getTime()
                        ) // Sort in descending order
                        ?.at(0)?.ActionDate
                    ) && record.PhoneNumber !== "0" ? (
                      <Popconfirm
                        title={`آیا از ارسال مجدد پیامک دعوتنامه برای  ${record.PhoneNumber} مطمئن هستید؟`}
                        okText="بله"
                        cancelButtonProps={{
                          className: "ant-btn-primary ant-btn-dangerous",
                          style: { color: "white" },
                        }}
                        cancelText="خیر"
                        onConfirm={() =>
                          SendInvitationSms(record.Id)
                            .then(() => LoadInvitations())
                            .then(() =>
                              openNotification(
                                "متن دعوتنامه مجددا پیامک شد",
                                "bottomRight"
                              )
                            )
                        }
                      >
                        <Tooltip title={"ارسال مجدد پیامک"}>
                          <a className="px-2" style={{ border: "1px" }}>
                            <RedoOutlined style={{ color: "green" }} />
                          </a>
                        </Tooltip>
                      </Popconfirm>
                    ) : null}

                    <Popconfirm
                      title="آیا از منقضی کردن این دعوت نامه مطمئن هستید؟"
                      okText="بله"
                      cancelButtonProps={{
                        className: "ant-btn-primary ant-btn-dangerous",
                        style: { color: "white" },
                      }}
                      cancelText="خیر"
                      onConfirm={() => UpdateInvitationAsync(4, record.Id)}
                    >
                      <Tooltip title={"منقضی کردن"}>
                        <a className="px-2" style={{ border: "1px" }}>
                          <ApiOutlined style={{ color: "red" }} />
                        </a>
                      </Tooltip>
                    </Popconfirm>

                    <Popconfirm
                      title={`آیا از ارسال ایمیل مجدد برای ${record.Email} مطمئن هستید؟`}
                      okText="بله"
                      cancelButtonProps={{
                        className: "ant-btn-primary ant-btn-dangerous",
                        style: { color: "white" },
                      }}
                      cancelText="خیر"
                      onConfirm={() =>
                        SendInvitationEmail(record.Id)
                          .then(() => LoadInvitations())
                          .then(() => {
                            openNotification(
                              "ایمیل با موفقیت ارسال شد",
                              "bottomRight"
                            );
                          })
                      }
                    >
                      <Tooltip title={"ارسال ایمیل"}>
                        <a className="px-2" style={{ border: "1px" }}>
                          <SendOutlined style={{ color: "black" }} />
                        </a>
                      </Tooltip>
                    </Popconfirm>
                  </>
                ) : null}

                <Tooltip title={"ویرایش"}>
                  <a className="px-2" style={{ border: "1px" }}>
                    <EditOutlined
                      onClick={() => {
                        setInvitationEditData(record);
                        SetNewInvitationDialog(true);
                      }}
                      style={{ color: "black" }}
                    />
                  </a>
                </Tooltip>
              </div>
            </div>
          ) : (
            <Button type="default" onClick={() => SetButtonCoverId(record.Id)}>
              عملیات
            </Button>
          )}
        </>
      ),
    },
  ];
  //Table Column End
  const handleComponentChange = () => {
    navigate("/CollabratingCompanies?tab=2");
    LoadInvitations();
    SetNewInvitationDialog(false);
  };
  const [getInvitationEditData, setInvitationEditData] = useState(null);
  return (
    <>
      {contextHolder}

      {getMyPosition !== null ? (
        <>
          <div
            className="col-12 "
            style={{
              display: "inline-flex",

              backgroundColor: "transparent",
            }}
          >
            {/* <div className="d-block">
              {SendInvitation === true ? (
                <>
                  <Button
                    onClick={() => {
                      setInvitationEditData(null);
                      SetNewInvitationDialog(true);
                      // openNotification("درحال بروزرسانی", "bottomRight");
                    }}
                    style={{
                      fontSize: "0.8em",
                    }}
                    className="iran p-button-rounded"
                  >
                    دعوتنامه جدید
                  </Button>
                  <Button
                    onClick={() => {
                      setInvitationEditData(null);
                      SetInvitaionLoading(true);
                      setTake(100000);
                      //here
                    }}
                    disabled={GetInvitationLoading}
                    style={{
                      fontSize: "0.8em",
                    }}
                    className="px-2  mx-2 iran p-button-rounded"
                  >
                    نمایش همه دعوتنامه ها
                  </Button>
                </>
              ) : (
                <></>
              )}
              <div className="d-flex my-3" style={{ width: "20%" }}>
                <Input
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="شماره همراه"
                />
                <Button onClick={LoadInvitations} className="mx-2">
                  جستجو
                </Button>
              </div>
            </div> */}
            <div
              dir="rtl"
              className="mt-2 ag-theme-alpine"
              style={{
                float: "right",
                display: "flex",
                width: isRowClicked ? "69%" : "99%",
                marginRight: "10px",
                margin: "auto",
                height: clientHeight - 210,
                overflow: "scroll",
                //scrollbarWidth: "thin",
                backgroundColor: "transparent",
                transition: "width 0.3s ease-in-out",
              }}
            >
              <ConfigProvider locale={locale} direction="rtl">
                <Table
                  loading={{
                    spinning: loading,
                    indicator: <Spin size="large" />,
                  }}
                  size="small"
                  scroll={{ y: clientHeight - 355 }}
                  dataSource={GetInvitationData}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total: pagination.total,
                    pageSizeOptions: ["10", "15", "20"],
                    showSizeChanger: true, // Show page size changer
                    showTotal: (total, current) =>
                      `  ${current[0]}  الی ${current[1]} از ${pagination.total}`, // Show total count of rows
                    position: ["bottomRight"], // Position of the pagination
                    style: { marginRight: "10px" },
                    className: "custom-pagination",
                  }}
                  onRow={(record) => ({
                    onClick: () => {
                      console.log("Selected Row Data:", record); // Log row data
                      setSelectedRow(record); // Store selected row data
                      setIsRowClicked(false); // Open the side div
                    },
                  })}
                  columns={columnsTotal}
                  onChange={handleTableChange}
                  style={{
                    border: "1px solid #d9d9d9",
                    borderRadius: "5px",
                    overflow: "scroll",
                    //scrollbarGutter: "auto",
                    //scrollbarWidth: "thin",
                    fontFamily: "YekanBakhVF",
                    transition: "opacity 0.3s ease-in-out",

                    marginBottom: "16px",
                  }}
                />
              </ConfigProvider>
            </div>
            {isRowClicked && (
              <Card
                className="mt-2"
                style={{
                  width: "30%",
                  margin: "auto",
                  marginBottom: "16px",
                  height: clientHeight - 197,
                  borderRadius: "5px",
                  border: "1px solid #D9D9D9",
                  transition: "opacity 0.3s ease-in-out",
                }}
              >
                <div
                  style={{
                    padding: "16px",
                    background: "#fafafa",
                    height: "52px",
                    borderRadius: "5px 5px 0px 0px",
                    borderBottom: "1px solid #D9D9D9",
                    transition: "opacity 0.3s ease-in-out",
                  }}
                >
                  <div style={{ display: "inline" }}>
                    <span>
                      <TedInvitationSideBarCompanyIcon />
                    </span>
                    <span
                      className="mx-2"
                      style={{
                        fontSize: "14px",
                        fontWeight: 450,
                        color: ColorPalette.primaryBlue[500],
                        lineHeight: "25.2px",
                      }}
                    >
                      {selectedRow?.CompanyName}
                    </span>
                  </div>
                  <div style={{ display: "inline", float: "left" }}>
                    <span
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: 450,
                        color: ColorPalette.primaryBlue[500],
                        lineHeight: "25.2px",
                      }}
                      onClick={() => setIsRowClicked(false)}
                    >
                      بستن
                    </span>
                  </div>
                  <div>
                    <div
                      style={{
                        borderRadius: "8px",
                        marginTop: "2rem",
                        height: "55px",
                        textAlign: "right",
                        color: ColorPalette.gray[800],
                        fontSize: "14px",
                        fontWeight: 325,
                        lineHeight: "25.2px",
                        verticalAlign: "middle",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        backgroundColor: ColorPalette.primaryBlue[50],
                      }}
                    >
                      <span className="mx-3">آمار تعاملات :</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      تعداد کل :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      43
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      تعداد معاملات باز{" "}
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      3
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      تاریخ آخرین معامله :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      1400/02/17
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      سابقه همکاری :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      12 ماه
                    </span>
                  </div>
                  <div>
                    <div
                      className="mt-5"
                      style={{
                        borderRadius: "8px",
                        marginTop: "2rem",
                        height: "55px",
                        textAlign: "right",
                        color: ColorPalette.gray[800],
                        fontSize: "14px",
                        fontWeight: 325,
                        lineHeight: "25.2px",
                        verticalAlign: "middle",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        backgroundColor: ColorPalette.primaryBlue[50],
                      }}
                    >
                      <span className="mx-3"> افراد مرتبط :</span>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      امیرمهدی موسی زاده :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      09058129495
                    </span>
                  </div>
                  <br />
                  <div
                    style={{
                      color: ColorPalette.gray[950],
                      fontSize: "14px",
                      fontWeight: 325,
                      lineHeight: "25.2px",
                    }}
                    className="mt-3"
                  >
                    <span
                      style={{
                        display: "inline",
                        float: "right",
                        marginRight: "10px",
                      }}
                    >
                      نگین روشن :
                    </span>
                    <span
                      style={{
                        display: "inline",
                        float: "left",
                        marginLeft: "10px",
                      }}
                    >
                      09121234567
                    </span>
                  </div>

                  <div>
                    <div
                      className="mt-5"
                      style={{
                        borderRadius: "8px",
                        marginTop: "2rem",
                        height: "55px",
                        textAlign: "right",
                        color: ColorPalette.gray[800],
                        fontSize: "14px",
                        fontWeight: 325,
                        lineHeight: "25.2px",
                        verticalAlign: "middle",
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        backgroundColor: ColorPalette.primaryBlue[50],
                      }}
                    >
                      <span className="mx-3"> آگهی های باز :</span>
                    </div>
                  </div>
                  <>
                    <Row
                      style={{
                        fontFamily: "YekanBakhVF",
                        textAlign: "center",
                        height: "182px",
                        marginTop: "16px",
                        marginLeft: "10px",
                        //zIndex: -99,
                      }}
                    >
                      <Col
                        //onClick={() => navigate(`/notice/${notice.id}`)}
                        style={{
                          borderBottom: "1px solid #DDE1E6",
                          width: "100%",

                          marginRight: "12px",
                          cursor: "pointer",
                        }}
                      >
                        <Row
                          style={{
                            textAlign: "center",
                            marginTop: "16px",
                            backgroundColor: "transparent",
                          }}
                        >
                          <Col
                            style={{
                              width: "95%",
                              height: "150px",
                              backgroundColor: "transparent",
                              margin: "auto",
                            }}
                          >
                            <Row>
                              <Col
                                style={{ width: "100%", overflow: "hidden" }}
                              >
                                <Row
                                  style={{
                                    textAlign: "right",
                                    height: "50px",
                                    paddingTop: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Col
                                    style={{
                                      fontFamily: "YekanBakhVF",
                                      height: "50px",
                                    }}
                                  >
                                    دستگاه برش لیزر و حکاکی فلزات
                                  </Col>
                                </Row>
                                <Row style={{ height: "22px" }}>
                                  <Col
                                    style={{
                                      color: ColorPalette.gray[700],
                                      fontFamily: "YekanBakhVF",
                                    }}
                                  >
                                    صنعتی
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    width: "100%",
                                    color: ColorPalette.gray[500],
                                    marginTop: "20px",
                                  }}
                                >
                                  <Col
                                    style={{
                                      width: "100%",
                                    }}
                                  >
                                    <Row
                                      style={{
                                        textAlign: "right",
                                      }}
                                    >
                                      <Col style={{ paddingLeft: "5px" }}>
                                        <ClockIcon />
                                      </Col>
                                      <Col style={{ width: "23rem" }}>
                                        بیست ساعت پیش
                                      </Col>
                                      <Col
                                        style={{
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        <Row style={{ textAlign: "left" }}>
                                          <Col style={{ width: "1rem" }}>
                                            <TedOneLineChatIcon />
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                </div>
              </Card>
            )}
            <Modal
              open={getNewInvitationDialog || isAddPresent}
              footer={null}
              width={700}
              onCancel={() => navigate("/CollabratingCompanies?tab=2")}
            >
              <div style={{ width: "700px" }}>
                <NewCompanyInvitationV2
                  invitationEditData={getInvitationEditData}
                  onComponentChange={handleComponentChange}
                />
              </div>
            </Modal>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div
            className="mt-5 iran"
            style={{ textAlign: "center", margin: "auto" }}
          >
            <p>کاربر گرامی شما دارای هیچ سمتی در هیچ فروشگاهی نمیباشید . </p>
            <img height={300} width={300} src={NoPosition} />
          </div>
        </>
      )}
    </>
  );
};
export default CompanyInvitationsV2;
